import { webSentryClientOptions } from '@agilix/ui/webSentry'
import * as Sentry from '@sentry/astro'
import { SENTRY_TUNNEL_PATH } from './src/utils/sentryDsn'

Sentry.init({
  // The shared options carry the `web` DSN, which the tunnel route accepts by exact match.
  ...webSentryClientOptions('home'),
  // Same-origin tunnel (src/pages/api/monitoring.ts) - a direct ingest.sentry.io request is blocked by
  // Firefox ETP and ad blockers, so those users' errors never arrived.
  tunnel: SENTRY_TUNNEL_PATH,
  sendDefaultPii: true,
  // Session replays stay off (the shared default), because the tunnel above carries EVERY envelope kind,
  // including replay recordings, which this package captures unmasked (maskAllText/maskAllInputs false below)
  // from pages that contain the buyer's e-mail field. Replay on a real error is the case worth recording.
  replaysOnErrorSampleRate: 1,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      maskAllInputs: false,
      blockAllMedia: false,
    }),
  ],
})
